__turbopack_context__.v({
  "transparent": "Image-module-scss-module__9r6Nuq__transparent",
});
